import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch, useAppSelector } from '../../store';
import { fetchServices, deleteService } from '../../store/feature/serviceSlice'; // Redux actions
import Swal from 'sweetalert2';
import BASE_URL from '../../constants/Config';

const ServiceList: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { services, loading } = useAppSelector((state) => state.service);

  useEffect(() => {
    dispatch(fetchServices());
  }, [dispatch]);

  const truncateText = (text: string, maxLength: number) =>
    text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

  const handleDelete = async (serviceId: number) => {
    try {
      await dispatch(deleteService(serviceId)).unwrap();
      Swal.fire('Başarılı', 'Hizmet Başarıyla silindi', 'success');
    } catch (err) {
      Swal.fire('Error', 'An error occurred while deleting the service.', 'error');
      console.error('Error deleting service:', err);
    }
  };

  const getPhotoUrl = (filePath: string) => {
    const fileName = filePath.split('/').pop();
    return `${BASE_URL}/api/OurServices/photo/${fileName}`; // Fotoğrafın API üzerinden çağrılması
  };

  if (loading) {
    return <p className="text-center text-gray-500">Hizmetler Yükleniyor...</p>;
  }

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-6">Hizmetlerimiz</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((service) => (
          <div
            key={service.id}
            className="bg-white shadow-md rounded-lg p-4 flex flex-col justify-between"
            style={{ height: '400px' }}
          >
            <img
              src={getPhotoUrl(service.photoUrl)}
              alt={service.title}
              className="w-full h-48 object-cover rounded-md mb-4"
            />
            <h3 className="text-lg font-bold mb-2">{service.title}</h3>
            <p className="text-sm text-gray-600">{truncateText(service.content, 150)}</p>
            <button
              onClick={() => handleDelete(service.id)}
              className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition duration-300 mt-4"
            >
              Sil
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceList;
